(function (Drupal) {
  Drupal.behaviors.Acordeon = {
    attach: function (context, settings) {
      const headers = document.querySelectorAll('.paragraph--type--details .accordion-item');  
      headers.forEach(header => {
        header.addEventListener('click', function() {
          const activeHeader = document.querySelector('.accordion-item.active');
          if (activeHeader && activeHeader !== this) {
            activeHeader.classList.remove('active');
            activeHeader.nextElementSibling.classList.remove('active');
          }
          this.classList.toggle('active');
          this.nextElementSibling.classList.toggle('active');
        });
      });
    }
  }
})(Drupal);